<template>
    <div class="col-sm-6 col-md-6 col-lg-4 p-3">
        <vue-card>
            <header slot="header">
                {{actuator.alias}}
                <div class="pull-right" v-if="actuator.sensor">Reading: {{reading}}</div>
            </header>
            <form>
                <div class="form-row">
                    <!-- <div class="form-group col-sm-6 col-md-6 col-lg-6"> -->
                    <div class="col">
                        <button
                            class="btn w-100"
                            :class="actuator.state != 'HIGH' ? 'btn-primary' : 'btn-secondary'"
                            @click="setActuator(actuator.name, 'off')"
                        >off</button>
                    </div>
                    <!-- <div class="form-group col-sm-6 col-md-6 col-lg-6"> -->
                    <div class="col">
                        <button
                            class="btn w-100"
                            :class="actuator.state == 'HIGH' ? 'btn-primary' : 'btn-secondary'"
                            @click="setActuator(actuator.name, 'on')"
                        >on</button>
                    </div>
                </div>
            </form>
            <footer slot="footer" class="small">
                {{$t('lastupdate')}}: {{ timestamp }}
                <a
                    class="float-right"
                    data-toggle="collapse"
                    :href="'#'+collapseName"
                    role="button"
                    aria-expanded="false"
                    :aria-controls="collapseName"
                >Show details</a>
                <div class="collapse" :id="collapseName">
                    <hr />
                    <pre>
                        <p class v-for="(item, name) in actuator" :key="name">{{ name }}: {{item}}</p>
                    </pre>
                </div>
            </footer>
        </vue-card>
    </div>
</template>

<style scoped>
.danger {
    border: 1px solid red;
}
</style>

<script>
import moment from "moment";

export default {
    props: ["actuator", "reading"],
    data() {
        return {
            quantity: 0,
            collapseName: "collapsePre" + this.actuator.name,
        };
    },
    computed: {
        timestamp: function () {
            return moment(this.actuator.timestamp).format(
                "dddd DD.MM.YYYY HH:mm"
            );
        },
    },

    created() {
        const app = this;
        if (app.actuator.sensor) {
            //app.getSensorData(app.actuator.sensor);
        }
    },
    methods: {
        setActuator(actuatorName, state) {
            var data = {
                name: actuatorName,
                state: state,
            };
            this.$emit("setActuator", data);
        },
    },
};
</script>